import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import DiscernSummary from '@components/DiscernSummary';

import MainWrapper from '@views/Records/Common/MainWrapper';

const messages = defineMessages({
  title: {
    id: 'discernMain.title',
    defaultMessage: 'Curation Dashboard',
  },
});

const Discern: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <MainWrapper
      backgroundIcon="discern"
      friendlyName={formatMessage(messages.title)}
      loading={false}
      title={formatMessage(messages.title)}
    >
      <DiscernSummary />
    </MainWrapper>
  );
};

export default Discern;
